import A11yDialog from 'a11y-dialog';
import Flickity from 'flickity';
import select from 'dom-select';
import { setCookie } from '@lib/cookies';

export const Modal = (el) => {
  const ui = {
    el,
    body: select('body'),
    closeBtn: select('.modal__close', el),
    carousel: select('.carousel__container', el),
    iframe: el.querySelector('iframe'),
    video: el.querySelector('iframe[src*="www.youtube.com"], iframe[src*="player.vimeo.com"], video')
  };

  const { id } = ui.el;

  const stopVideo = function (el) {
    if (ui.video) {
      ui.video.src = ui.video.src.replace('&autoplay=1', '').replace('?autoplay=1', '');
    }
  }

  const startVideo = function (el) {
    if (ui.video) {
      // ui.video.src = ui.video.src + (ui.video.src.indexOf('?') < 0 ? '?' : '&') + 'autoplay=1';
      // console.log('autoplay!');
    }
  }

  const toggleBodyLock = function (el) {
    if (ui.body.classList.contains('lock-body')) {
      ui.body.classList.remove('lock-body');
    } else {
      ui.body.classList.add('lock-body');
    }
  }

  ui.toggle = document.querySelector(`#opens--${id}`);

  const dialog = new A11yDialog(ui.el);

  const addEvents = () => {

    if(typeof(ui.toggle) != 'undefined' && ui.toggle != null){
      ui.toggle.addEventListener('click', () => {
        dialog.show();
      });
    }

    dialog.on('show', () => {
      ui.closeBtn.blur();

      if (ui.carousel) {
        const flkty = Flickity.data(ui.carousel);
        ui.carousel.classList.add('is-open');
        flkty.resize();
      }

      toggleBodyLock();
      startVideo();
    });

    dialog.on('hide', () => {
      if (ui.carousel) {
        ui.carousel.classList.remove('is-open');
      }

      toggleBodyLock();
      stopVideo();

      if (ui.el.classList.contains('modal--speedbump')) {
        const alertTimestamp = ui.closeBtn.getAttribute('data-popup-timestamp');
        const popupID = ui.closeBtn.getAttribute('data-popup-id')
        const frequencyInDays = ui.closeBtn.getAttribute('data-popup-frequency')
        const cookieName = 'vb_pop_' + popupID;
        setCookie(cookieName, alertTimestamp, frequencyInDays);

        dialog.destroy();
      }
    });

    dialog.on('destroy', () => {
      if (ui.el.classList.contains('modal--speedbump')) {
        // these 'speedbump' popups have the possibility of many instances being rendered on an page-load.
        // as such, we need to kill the overlay completely as previous, single-instance hide relied on
        // `.modal[aria-hidden=true]`
        // This doesn't work when multi-instances are on page as only the most recently closed will have the
        // [aria-hidden=true] attribute applied, thus, re-engaging previously dismissed overlays
        const overlay = ui.el.querySelector('.modal__overlay');
        overlay.remove();
      }
    });

  };


  const init = () => {
    addEvents();
  };

  init();
};

export default Modal;
